import FacetedFilters from '../components/FacetedFilters';

export default class StaticSearch {
  constructor(section) {
    this.facetedFilters = new FacetedFilters(section);
  }

  onSectionUnload() {
    this.facetedFilters.unload();
  }
}
